import forgot1 from '/public/siteImages/iOSTheme/forgotPassword/theme1/forgot1.png';
import forgot2 from '/public/siteImages/iOSTheme/forgotPassword/theme1/forgot2.png';
import forgot3 from '/public/siteImages/iOSTheme/forgotPassword/theme2/forgot3.png';
import forgot4 from '/public/siteImages/iOSTheme/forgotPassword/theme2/forgot4.png';
import forgot5 from '/public/siteImages/iOSTheme/forgotPassword/theme3/forgot5.png';
import forgot6 from '/public/siteImages/iOSTheme/forgotPassword/theme3/forgot6.png';
import forgot7 from '/public/siteImages/iOSTheme/forgotPassword/theme4/forgot7.png';
import forgot8 from '/public/siteImages/iOSTheme/forgotPassword/theme4/forgot8.png';

export {
    forgot1,
    forgot2,
    forgot3,
    forgot4,
    forgot5,
    forgot6,
    forgot7,
    forgot8
}